import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_153_lookup_summary: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Lookups",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        Label: "",
        BindValue: "cont_Action",
        style: {
          direction: FlexDirection.ROW,
        },
        childComponents: [], // ButtonStrip empty in provided JSON
      },
      {
        componentType: ComponentType.SUMMARY_LIST,
        Name: "lookup_summary",
        BindValue: "grid_lookup",
        titleValue: "Lookups",
        SummeryActions: [
          {
            Action: {
              Action: "Navigate",
              Navigate: "modulev1/lookup_add/<id>",
              Module: "lookup_name",
            },
            ActionType: "Edit",
            ScreenId: "153_add",
          },
          {
            Action: {
              Action: "Delete",
              Module: "lookup_summary",
            },
            ActionType: "Delete",
            ScreenId: "23",
          },
        ],
        Form: {
          Name: "lookup_summary",
          TableName: "lookup_name",
          DisplayName: "Lookup",
          Filter: " lookup_name.hidden <> 1",
          Fields: [
            {
              IncludeLabel: true,
              Label: "id",
              BindValue: "id",
              Json_Attribute: "id",
              showInSummary: false,
              IsPrimary: true,
            },
            {
              IncludeLabel: true,
              Label: "Name",
              BindValue: "name", // Normalized to match Json_Attribute as requested
              Json_Attribute: "name",
              showInSummary: true,
            },
          ],
        },
      },
    ],
  },
];
